export function checkShouldBeLocked({
  permissions,
  scopes,
  gates,
  crmObjects,
  isBulkAction,
  permissionsExtraData
}) {
  if (!permissions) {
    return false;
  }
  const isMissingRequiredScopes = permissions.scopes ? permissions.scopes.some(scope => !scopes.includes(scope)) : false;
  const isMissingRequiredGates = permissions.gates ? permissions.gates.some(gate => !gates.includes(gate)) : false;
  const failsCustomValidation = permissions.custom ? permissions.custom({
    scopes,
    gates,
    crmObjects,
    isBulkAction,
    permissionsExtraData
  }) : false;
  return isMissingRequiredScopes || isMissingRequiredGates || failsCustomValidation;
}
export function checkPermissions({
  permissions,
  scopes,
  gates,
  crmObjects,
  isBulkAction,
  permissionsExtraData
}) {
  if (!permissions) {
    return true;
  }
  const hasScopes = permissions.scopes ? permissions.scopes.every(scope => scopes.includes(scope)) : true;
  const hasGates = permissions.gates ? permissions.gates.every(gate => gates.includes(gate)) : true;
  const passesCustomValidation = permissions.custom ? permissions.custom({
    scopes,
    gates,
    crmObjects,
    isBulkAction,
    permissionsExtraData
  }) : true;
  return hasScopes && hasGates && passesCustomValidation;
}